<template>
  <WdsStack direction-column class="tw-gap-7">
    <MetricsNumbers :metrics="metrics" :loading="loading" />

    <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-7">
      <div class="tw-flex tw-flex-col tw-gap-7 tw-w-full md:tw-w-1/2">
        <UpcomingActions />
        <SourcingActivity />
      </div>

      <div class="tw-flex tw-flex-col tw-gap-7 tw-w-full md:tw-w-1/2">
        <Workforce />
        <ProjectTracker />
      </div>
    </div>
  </WdsStack>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsStack } from '@worksome/wds-components'
import { useQuery } from '@vue/apollo-composable'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { DashboardMetricsQuery } from '@/components/Dashboard/Metrics/queries'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import laravelNamedRoutes from '@/utils/laravelNamedRoutes.json'
import MetricsNumbers from '@/components/Dashboard/Metrics/MetricsNumbers.vue'
import UpcomingActions from '@/components/Dashboard/Widgets/UpcomingActions/UpcomingActions.vue'
import SourcingActivity from '@/components/Dashboard/Widgets/SourcingActivity.vue'
import Workforce from '@/components/Dashboard/Widgets/Workforce.vue'
import ProjectTracker from '@/components/Dashboard/Widgets/ProjectTracker.vue'

const account = computed(() => currentAccount.globalId)

const { result, loading } = useQuery(
  DashboardMetricsQuery,
  () => ({
    accounts: [account.value],
  }),
  {
    clientId: 'publicApi',
  },
)

const metrics = computed(() => [
  {
    label: $t('Unfilled jobs'),
    value: result.value?.unfilledJobs.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(laravelNamedRoutes.frontend.jobs.index.created, {
      unfilled: 'dHJ1ZQ==',
    }),
  },
  {
    label: $t('Active hires'),
    value: result.value?.activeContracts.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(laravelNamedRoutes.frontend.profiles.index.engaged, {
      activeStatus: 'W3sibGFiZWwiOiJBY3RpdmUiLCJ2YWx1ZSI6IkFDVElWRSJ9XQ==',
    }),
  },
  {
    label: $t('Unsigned contracts'),
    value: result.value?.unsignedContracts.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(laravelNamedRoutes.frontend.profiles.index.engaged, {
      activeStatus: 'W3sibGFiZWwiOiJPZmZlcmVkIiwidmFsdWUiOiJPRkZFUkVEIn1d',
    }),
  },
  {
    label: $t('Requests to join talent pool'),
    value: result.value?.talentPoolAppliedContacts.paginatorInfo.total ?? 0,
    url: laravelNamedRoute(laravelNamedRoutes.contacts.applied),
  },
])
</script>
